import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import { ApplicationInsightsService } from '../application-insights.service';
import { SummaryObject } from '../report/report.models';

@Injectable({
  providedIn: 'root',
})
export class DescriptionService {
  constructor(
    private appService: AppService,
    private applicationInsightsService: ApplicationInsightsService,
  ) {
    if (!this.appService.summaryObject) {
      this.appService.getSummaryContent('ALL');
    }
  }

  summaryData: SummaryObject[] = this.appService.summaryObject;

  private getObject(mbtiType: string): SummaryObject {
    if (mbtiType === '' || mbtiType === '----') return null;

    try {
      var result = this.summaryData.find((obj) => {
        return obj.mbtiType.toLowerCase() === mbtiType.toLowerCase();
      });
      return result;
    } catch (exception) {
      this.applicationInsightsService.logException(exception);
      return null;
    }
  }

  individualDescription(mbtiType: string): string {
    return this.getObject(mbtiType).individualDescription;
  }

  teamDescription(mbtiType: string): string {
    return this.getObject(mbtiType).teamDescription;
  }

  MbtiTypesLongForm(mbtiType: string): string {
    return this.getObject(mbtiType).mbtiTypeLong;
  }
}
